import type { IconNode } from '../types';

/**
 * @name flower-rose-single
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggOS41MmE0LjA0IDQuMDQgMCAxIDEgMi0zLjQ3IiAvPgogIDxjaXJjbGUgY3g9IjE3IiBjeT0iNy44IiByPSIyIiAvPgogIDxwYXRoIGQ9Im0xNCAyLjUtMiAxLjNhNiA2IDAgMSAwIDYgMTAuNGwyLTEuMmE0IDQgMCAwIDAtNC02Ljk1IiAvPgogIDxwYXRoIGQ9Ik05Ljc3IDEyQzQgMTUgMiAyMiAyIDIyIiAvPgogIDxwYXRoIGQ9Ik0xMyAyMHMtNSAzLTkuMi0yYzAgMCA1LjItMyA5LjIgMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/flower-rose-single
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const flowerRoseSingle: IconNode = [
  ['path', { d: 'M18 9.52a4.04 4.04 0 1 1 2-3.47', key: '15qodm' }],
  ['circle', { cx: '17', cy: '7.8', r: '2', key: '96iyw7' }],
  ['path', { d: 'm14 2.5-2 1.3a6 6 0 1 0 6 10.4l2-1.2a4 4 0 0 0-4-6.95', key: 'nbfjqy' }],
  ['path', { d: 'M9.77 12C4 15 2 22 2 22', key: 'h28rw0' }],
  ['path', { d: 'M13 20s-5 3-9.2-2c0 0 5.2-3 9.2 2', key: 'ysqwcb' }],
];

export default flowerRoseSingle;
